export default "__VITE_ASSET__G$8Y9ukX__"